module.exports = __webpack_public_path__ + "assets/img/crayon2.b09f368e.png";